// extracted by mini-css-extract-plugin
export default {"link":"sKVCXi","root":"wfaXDG","wrapper":"pdxnoF","container":"qJUeXq","bottom":"MIaYfj","ribbon":"z4WPN3","top":"wTbikq","label":"Fks0SL"};